//数磅差上下限
export const boundLimit = function (arr, d) {
    let temp = arr[0].lbsTimes
    let totalCheckAcceptWeight = 0
    let totalTagWeight = 0
    let list = []
    //從第一個磅次開始比較
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].lbsTimes === temp) {
            totalCheckAcceptWeight += Number(arr[i].checkAcceptWeight)
            totalTagWeight += Number(arr[i].tagWeight)
        } else {
            if (
                (totalCheckAcceptWeight - totalTagWeight) / totalCheckAcceptWeight >= d ||
                (totalCheckAcceptWeight - totalTagWeight) / totalCheckAcceptWeight <= -d) {
                list.push(arr[i - 1].lbsTimes) //把变红的磅次记录下来
            }
            temp = arr[i].lbsTimes
            totalCheckAcceptWeight = Number(arr[i].checkAcceptWeight)
            totalTagWeight = Number(arr[i].tagWeight)
        }
    }
    //比較最後一個磅次
    if (
        (totalCheckAcceptWeight - totalTagWeight) / totalCheckAcceptWeight >= d ||
        (totalCheckAcceptWeight - totalTagWeight) / totalCheckAcceptWeight <= -d) {
        list.push(temp) //把变红的磅次记录下来
    }
    return list

}

//合磅库存
export const boundLimit2 = function (arr, d) {
    let temp = arr[0].lbsTimes
    let totalCheckAcceptWeight = 0
    let totalTagWeight = 0
    let list = []
    //從第一個磅次開始比較
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].lbsTimes === temp) {
            totalCheckAcceptWeight += Number(arr[i].lbsWeight)
            totalTagWeight += Number(arr[i].inventoryWeight)
        } else {
            if (
                (totalCheckAcceptWeight - totalTagWeight) / totalTagWeight >= d ||
                (totalCheckAcceptWeight - totalTagWeight) / totalTagWeight <= -d) {
                list.push(arr[i - 1].lbsTimes) //把变红的磅次记录下来
            }
            temp = arr[i].lbsTimes
            totalCheckAcceptWeight = Number(arr[i].lbsWeight)
            totalTagWeight = Number(arr[i].inventoryWeight)
        }
    }
    //比較最後一個磅次
    if (
        (totalCheckAcceptWeight - totalTagWeight) / totalTagWeight >= d ||
        (totalCheckAcceptWeight - totalTagWeight) / totalTagWeight <= -d) {
        list.push(temp) //把变红的磅次记录下来
    }
    return list

}

export default {
    boundLimit,
    boundLimit2
}



// WEBPACK FOOTER //
// ./src/utils/method.js